namespace Areas.Account.PWC {
    "use strict";

    let projectId: number;
    let glDataId: number;
    let pwcglId: number;
    let accountId: number;
    let glDataAmount: number;
    let phaseLk: string;


    export function getProjectId() {
        return projectId;
    }

    export function onGridSelectionChanged(e: any) {
        var rowData: any = e.selectedRowsData[0];
        projectId = e.component.option("ProjectId");

        var rowForm: any = $("#PWCForm").dxForm("instance");
        rowForm.option("formData", rowData);

        let selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length === 1) {
            projectId = selectedRows[0].projectId;
            accountId = selectedRows[0].accountId;
            glDataId = selectedRows[0].glDataId;
            pwcglId = selectedRows[0].pwcglId;

            Areas.refreshGrid("PWCGLDataGrid");
        }
    }

    export function onGridPWCGLSelectionChanged(e: any) {
        var rowData: any = e.selectedRowsData[0];
        pwcglId = e.component.option("PWCGLId");
        accountId = e.component.option("AccountId");

        var rowGrid: any = $("#PWCGLDataGrid").dxDataGrid("instance");
        rowGrid.option("gridData", rowData);

        let selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length === 1) {
            pwcglId = selectedRows[0].pwcglId;
            accountId = selectedRows[0].accountId;
            glDataId = selectedRows[0].glDataId;
            phaseLk = selectedRows[0].phaseLk;
            glDataAmount = selectedRows[0].glDataAmount;
        }
    }

}
